import React from 'react';

const CDN = 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons';

const EXP_TECH = {
  'Royals Webtech Pvt. Ltd.': [
    { name: 'React',       src: `${CDN}/react/react-original.svg` },
    { name: 'Node.js',     src: `${CDN}/nodejs/nodejs-original.svg` },
    { name: 'MongoDB',     src: `${CDN}/mongodb/mongodb-original.svg` },
    { name: 'Spring Boot', src: `${CDN}/spring/spring-original.svg` },
    { name: 'MySQL',       src: `${CDN}/mysql/mysql-original.svg` },
    { name: 'Docker',      src: `${CDN}/docker/docker-original.svg` },
    { name: 'Redux',       src: `${CDN}/redux/redux-original.svg` },
  ],
  'All India Council for Technical Education (AICTE)': [
    { name: 'React',      src: `${CDN}/react/react-original.svg` },
    { name: 'JavaScript', src: `${CDN}/javascript/javascript-original.svg` },
    { name: 'HTML5',      src: `${CDN}/html5/html5-original.svg` },
    { name: 'CSS3',       src: `${CDN}/css3/css3-original.svg` },
  ],
  'StaxTech': [
    { name: 'Python',     src: `${CDN}/python/python-original.svg` },
    { name: 'TensorFlow', src: `${CDN}/tensorflow/tensorflow-original.svg` },
    { name: 'OpenCV',     src: `${CDN}/opencv/opencv-original.svg` },
  ],
};

function ExpTechTag({ item }) {
  const [err, setErr] = React.useState(false);
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 5,
      padding: '3px 8px 3px 5px', borderRadius: 4,
      border: '1px solid var(--border-color)',
      background: 'transparent',
      transition: 'border-color 0.15s',
    }}
      onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--accent-color)'}
      onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border-color)'}
    >
      {err ? null : (
        <img src={item.src} width="12" height="12" alt={item.name}
          onError={() => setErr(true)}
          style={{ filter: item.invert ? 'invert(0.8)' : 'none', display: 'block' }} />
      )}
      <span style={{ fontFamily: 'var(--mono)', fontSize: 7.5, letterSpacing: '0.5px', color: 'var(--text-muted)', textTransform: 'uppercase' }}>{item.name}</span>
    </div>
  );
}

const EXP = [
  {
    status: 'live',
    role: 'Full Stack Developer Intern',
    company: "Royals Webtech Pvt. Ltd.",
    date: 'Dec 2025 – Present',
    stats: [
      { val: '10K+', label: 'Users' },
      { val: '12×',  label: 'Login faster' },
      { val: '12×',  label: 'Data fetch' },
      { val: '5+',   label: 'Apps shipped' },
    ],
    bullets: [
      'Joined as bug fixer across production client projects. Consistently resolved issues faster than existing team — manager handed <span class="ehi">full ownership of flagship production system</span> serving 4 railway divisions. Optimized login <span class="ehi">12× (60s → 5s)</span> via lazy loading; data fetch <span class="ehi">12× (2min → 10s)</span> via scroll-based pagination.',
      'Built <strong>complete backend solo</strong> for an identity verification system — QR generation, face detection, multi-role workflow (Admin → Org Admin → Employee/Student). Serving <span class="ehi">10,000+ users across 20+ institutes</span>; direct client communication throughout.',
      'Co-built a <strong>real-time ordering platform</strong> for a transport network — unique QR per unit opens live vendor menu; <span class="ehi">3-role system</span>: User → Vendor → Admin monitors sales, ratings &amp; complaints.',
      'Co-built a <strong>GPS-based civic reporting system</strong> — photo evidence, auto-captured coordinates, <span class="ehi">6-role lifecycle</span>: report → assign → clean → verify → approve → notify; inventory module with live weight tracking.',
      'Delivered <strong>5+ client projects</strong> across logistics, civic tech, and hospitality — React frontends, Node.js/Java backends; direct client communication throughout.',
    ],
  },
  {
    status: 'done',
    role: 'Frontend Developer Intern',
    company: 'All India Council for Technical Education (AICTE)',
    date: 'Aug 2025- Oct 2025',
    location: 'Virtual',
    stats: [
      { val: 'AICTE', label: 'Govt. body' },
      { val: '3mo',   label: 'Duration' },
    ],
    bullets: [
      'Built responsive web interfaces using <strong>HTML, CSS, JavaScript, and React</strong>- accessible, cross-browser-tested, WCAG-aligned.',
      'Developed <strong>dynamic UI components</strong>; optimized screen layouts and improved overall cross-browser responsiveness.',
      'Followed best practices for <strong>clean code, accessibility, and design consistency</strong> in a project-based virtual environment.',
    ],
  },
  {
    status: 'done',
    role: 'AI / ML Intern',
    company: 'StaxTech',
    date: 'Jul 2025- Aug 2025',
    location: 'Nagpur',
    stats: [
      { val: 'AI/ML', label: 'Domain' },
      { val: '2mo',   label: 'Duration' },
    ],
    bullets: [
      'Worked on AI/ML projects including <strong>portfolio optimization</strong> and real-world predictive analysis pipelines.',
      'Gained hands-on experience with <strong>machine learning pipelines, data cleaning, and model implementation</strong>.',
      'Strengthened understanding of <strong>AI workflows and data-driven systems</strong>.',
    ],
  },
];

function StatChip({ val, label, live }) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      padding: live ? '8px 16px' : '6px 12px',
      borderRadius: 4,
      background: live ? 'var(--accent-glow)' : 'rgba(255,255,255,0.015)',
      border: '1px solid var(--border-color)',
      minWidth: 52, flexShrink: 0,
    }}>
      <span style={{ fontFamily: 'var(--bebas)', fontSize: live ? 20 : 16, letterSpacing: 1, color: 'var(--accent-color)', lineHeight: 1 }}>{val}</span>
      <span style={{ fontFamily: 'var(--mono)', fontSize: 7, letterSpacing: 0.5, color: 'var(--text-muted)', marginTop: 3, textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{label}</span>
    </div>
  );
}

export default function Experience() {
  return (
    <section id="experience">
      <div className="inn">
        <div className="shdr reveal">
          <div className="sn2">// work_experience</div>
          <h2 className="st">REAL<br />IMPACT</h2>
          <div className="sl2" />
        </div>

        <div className="ewrap">
          {EXP.map((exp, i) => (
            <div key={i} className="reveal" style={{ marginBottom: i < EXP.length - 1 ? '3.5rem' : 0 }}>
              {/* Company + live badge */}
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 4 }}>
                <div className="ecn">{exp.company}</div>
                {exp.status === 'live' && <div className="elive">LIVE</div>}
              </div>

              <div className="ecm">{exp.role} · {exp.location} · {exp.date}</div>

{/* Stats row */}
              <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
                {exp.stats.map((s, j) => <StatChip key={j} val={s.val} label={s.label} live={exp.status === 'live'} />)}
              </div>

              {/* Tech logos */}
              {EXP_TECH[exp.company] && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 18 }}>
                  {EXP_TECH[exp.company].map(t => <ExpTechTag key={t.name} item={t} />)}
                </div>
              )}

              {/* Bullets */}
              <ul className="ebs">
                {exp.bullets.map((b, j) => (
                  <li key={j} className="eb">
                    <div className="ebi">
                      <svg width="14" height="14" viewBox="0 0 14 14">
                        <path d="M7 1l1.8 3.6L13 5.3l-3 2.9.7 4.1L7 10.3l-3.7 2L4 8.2 1 5.3l4.2-.7L7 1z" fill="var(--accent-color)" />
                      </svg>
                    </div>
                    <div className="ebt" dangerouslySetInnerHTML={{ __html: b }} />
                  </li>
                ))}
              </ul>

              {i < EXP.length - 1 && (
                <div style={{ height: 1, background: 'linear-gradient(90deg, var(--border-color), transparent)', marginTop: '2.5rem' }} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}